function switchTab(tabId) {
  const tabContent = document.getElementById(tabId + '-content');
  if (!tabContent) return;

  // 全てのタブボタンから active クラスを削除
  const buttons = document.querySelectorAll('.tab-button');
  buttons.forEach(btn => btn.classList.remove('active'));

  // 全てのコンテンツを非表示にする
  const contents = document.querySelectorAll('.tab-content');
  contents.forEach(content => content.classList.remove('active'));

  // 選択されたタブボタンに active クラスを追加
  document.getElementById('tab-' + tabId).classList.add('active');

  // 対応するコンテンツを表示
  tabContent.classList.add('active');

  // 現在のタブをコンテナに持たせて CSS 側で表示を切り替える
  const favoriteProductsContainer = document.querySelector('.favorite-products-container');
  if (favoriteProductsContainer) {
    favoriteProductsContainer.dataset.activeTab = tabId;
  }

  // ハッシュを更新
  history.replaceState(null, '', '#' + tabId);
}

function getFixedHeaderBottom() {
  const headers = document.querySelectorAll('.headerBrand, .spHeaderBrand');
  let headerBottom = 0;

  headers.forEach(header => {
    const style = window.getComputedStyle(header);
    if (style.display === 'none' || style.visibility === 'hidden' || style.position !== 'fixed') return;

    const rect = header.getBoundingClientRect();
    if (rect.height === 0) return;

    headerBottom = Math.max(headerBottom, rect.bottom);
  });

  return headerBottom;
}

function scrollFavoriteTabsIntoView() {
  const tabWrapper = document.querySelector('.tab-wrapper');
  if (!tabWrapper) return;

  // 固定ヘッダーの直下にタブが来る位置へ補正する
  const tabTop = tabWrapper.getBoundingClientRect().top + window.scrollY;
  const headerBottom = getFixedHeaderBottom();
  const scrollTop = tabTop - headerBottom;
  window.scrollTo({
    top: Math.max(scrollTop, 0),
    behavior: 'auto'
  });
}

document.addEventListener("DOMContentLoaded", function() {
  const validTabIds = ['list-favorite', 'coordinate', 'staff'];
  const hashTabId = window.location.hash.replace('#', '');
  const tabId = validTabIds.includes(hashTabId) ? hashTabId : 'list-favorite';

  switchTab(tabId);

  // activeクラス反映後のレイアウト確定を待ってタブ位置を補正する
  requestAnimationFrame(() => {
    requestAnimationFrame(scrollFavoriteTabsIntoView);
  });
});
